// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'C:/Work/3_virgin/project/7_twins/code/official/twins-web-react/src/models/user';
import model_2 from 'C:/Work/3_virgin/project/7_twins/code/official/twins-web-react/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'user', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
